import React from 'react';
import {
    Col, Row, Modal, Form, FormGroup, FormControl, ControlLabel
} from 'react-bootstrap';
import Select from 'react-select';
import decode from 'jwt-decode';
import HighlightsService from '../../services/HighlightsService';
import Checkbox from '../../elements/CustomCheckbox/CustomCheckbox.jsx';
import Button from '../../elements/CustomButton/CustomButton.jsx';

class ModalRegistro extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fecha: new Date(),
      currentUser: decode(localStorage.getItem('id_token')),
      observaciones: '',
      sugerencias: '',
      objetivos: '',
      sede: '',
      asistentes: '',
      fechaprox: '',
      horainicio: '',
      horafin: '',
      fechainicio: '',
      horaprox: '',
      avances: '',
      mentor: '',
      firmaemprendedor: null,
      firmamentor: null,
      firmatutor: null,
      firmaasistentes: null,
      error: {},
      avancesChecked: false,
      observacionesChecked: false,
      sugerenciasChecked: false,
      tutores:'',
    };
    this.highlightsService = new HighlightsService();
    this.onChangeObservaciones = this.onChangeObservaciones.bind(this);
    this.onChangeObjetivos = this.onChangeObjetivos.bind(this);
    this.onChangeSugerencias = this.onChangeSugerencias.bind(this);
    this.onChangeAsistentes = this.onChangeAsistentes.bind(this);
    this.onChangeSede = this.onChangeSede.bind(this);
    this.onChangeFechaProx = this.onChangeFechaProx.bind(this);
    this.onChangeHoraProx = this.onChangeHoraProx.bind(this);
    this.onChangeAvances = this.onChangeAvances.bind(this);
    this.onChangeTutores = this.onChangeTutores.bind(this);
    this.checkErrors = this.checkErrors.bind(this);
    this.clearError = this.clearError.bind(this);
    this.onSave = this.onSave.bind(this);
  }

  onChangeObservaciones(value) {
    this.setState({ observaciones: value });
  }

  onChangeSugerencias(value) {
    this.setState({ sugerencias: value });
  }

  onChangeObjetivos(value) {
    this.setState({ objetivos: value });
    this.clearError('objetivosconsulta');
  }

  onChangeAsistentes(value) {
    this.setState({ asistentes: value });
    this.clearError('asistentes');
  }

  onChangeSede(value) {
    this.setState({ sede: value });
  }

  onChangeFechaProx(value) {
    this.setState({ fechaprox: value });
    this.clearError('fechaproxima');
  }

  onChangeHoraProx(value) {
    this.setState({ horaprox: value });
    this.clearError('horaproxima');
  }

  onChangeFecha(value) {
    this.setState({ fechainicio: value });
    this.clearError('fecha');
  }

  onChangeHoraInicio(value) {
    this.setState({ horainicio: value });
    this.clearError('horainicio');
  }

  onChangeHoraFin(value) {
    this.setState({ horafin: value });
    this.clearError('horafin');
  }

  onChangeAvances(value) {
    this.setState({ avances: value });
  }

  onChangeTutores(value) {
    this.setState({ tutores: value });
  }

  clearError(key) {
    const auxError = this.state.error;
    auxError[key] = false;
    this.setState({error: auxError});
  }

  checkErrors(registro, array) {
    const auxError = this.state.error;
    let error = false;
    Object.keys(registro).forEach((key) => {
      if (array.includes(key)) {
        if (!registro[key] || registro[key] === '') {
          auxError[key] = true;
          error = true;
        }
      }
    });
    this.setState({error: auxError});
    return error;
  }

  onSave() {
    const fieldsToCheckRAT = ['fecha', 'horainicio', 'horafin', 'asistentes', 'objetivosconsulta', 'fechaproxima', 'horaproxima'];
    const fieldsToCheckRM = ['fecha', 'horainicio', 'horafin', 'mentor', 'asistentes', 'objetivosconsulta'];
    const fieldsToCheckRT = ['fecha', 'horainicio', 'horafin', 'asistentes', 'objetivosconsulta', 'fechaproxima', 'horaproxima'];
    let idEstado;
    switch (this.props.estado) {
      case 'Pre Seleccion':
        idEstado = 3;
        break;
      case 'Pre Incubacion':
        idEstado = 4;
        break;
      case 'Incubacion':
        idEstado = 5;
        break;
      default:
        idEstado = -1;
    }
    const registro = {
      idproyectoincubacion: this.props.idproyectoincubacion,
      idestado: idEstado,
      fecha: this.state.fechainicio,
      horainicio: this.state.horainicio,
      horafin: this.state.horafin,
      iduser: this.state.currentUser.id,
      lugar: this.state.sede,
      mentor: this.state.mentor.label,
      asistentes: this.state.asistentes,
      objetivosconsulta: this.state.objetivos,
      avances: this.state.avances,
      observaciones: this.state.observaciones,
      sugerencias: this.state.sugerencias,
      fechaproxima: this.state.fechaprox,
      horaproxima: this.state.horaprox,
      firmatutor: this.state.firmatutor ? 1 : 0,
      firmamentor: this.state.firmamentor ? 1 : 0,
      firmaemprendedor: this.state.firmaemprendedor ? 1 : 0,
      firmaasistentes: this.state.firmaasistentes ? 1 : 0,
      createdby: this.state.currentUser.username,
      tutores: this.state.tutores,
    };
    let error;
    switch (this.props.type) {
      case 'RAT':
        error = this.checkErrors(registro, fieldsToCheckRAT);
        break;
      case 'RM':
        error = this.checkErrors(registro, fieldsToCheckRM);
        break;
      case 'RT':
        error = this.checkErrors(registro, fieldsToCheckRT);
        break;
      default: //this can't happen
    }

    if (!error) {
      this.props.save(registro);
      if (this.state.observacionesChecked) {
        this.highlightsService.postHighlights(
          {
            idproyecto: this.props.idproyectoincubacion,
            nota: this.state.observaciones,
            campo: 'Observaciones',
          }
        ).catch(err => {
          this.props.setError(
            <div>Hubo un error al cargar el campo destacado</div>
          );
        });
      }
      if (this.state.sugerenciasChecked) {
        this.highlightsService.postHighlights(
          {
            idproyecto: this.props.idproyectoincubacion,
            nota: this.state.sugerencias,
            campo: 'Sugerencias',
          }
        ).catch(err => {
          this.props.setError(
            <div>Hubo un error al cargar el campo destacado</div>
          );
        });
      }
      if (this.state.avancesChecked) {
        this.highlightsService.postHighlights(
          {
            idproyecto: this.props.idproyectoincubacion,
            nota: this.state.avances,
            campo: 'Avances Previstos',
          }
        ).catch(err => {
          this.props.setError(
            <div>Hubo un error al cargar el campo destacado</div>
          );
        });
      }
    } else {
      this.props.setError(
        <div>
          Uno o mas campos requeridos no han sido completados!
        </div>);
    }
  }

  render() {
    const fecha = this.state.fecha.toLocaleDateString('es-ES', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
    const mentoresList = [];
    this.props.mentores && this.props.mentores.forEach((mentor) => {
      mentoresList.push({value: mentor.id, label: mentor.username });
    })
    return (
      <div>
        <Modal.Body>
          <div>
            <Form horizontal>
              <Row>
                <Col md={9}></Col>
                <Col md={3}>
                  <FormGroup>
                    <Col componentClass={ControlLabel} md={12} style={{textAlign:'left', paddingTop: '7px'}}>
                      {fecha.charAt(0).toUpperCase() + fecha.slice(1)}
                    </Col>
                  </FormGroup>
                </Col>
              </Row>
              <FormGroup>
                <Col componentClass={ControlLabel} md={1} style={{textAlign:'left', paddingTop: '7px'}}>
                  Etapa:
                </Col>
                <Col md={11}>
                  <FormControl
                    type="text" value={this.props.estado}  disabled
                  />
                </Col>
              </FormGroup>
              <FormGroup>
                <Col componentClass={ControlLabel} md={1} style={{textAlign:'left', paddingTop: '7px'}}>
                  Proyecto:
                </Col>
                <Col md={11}>
                  <FormControl
                    type="text" value={this.props.nombreproyecto}  disabled
                  />
                </Col>
              </FormGroup>
              <FormGroup>
                <Col componentClass={ControlLabel} md={1} style={{textAlign:'left', paddingTop: '7px'}}>
                  Tutor:
                </Col>
                <Col md={11}>
                  <FormControl
                    type="text" value={this.state.currentUser.username}  disabled
                  />
                </Col>
              </FormGroup>
              <Row>
                <Col md={4}>
                  <FormGroup validationState={this.state.error.fecha ? 'error': null}>
                    <Col componentClass={ControlLabel} md={3} style={{textAlign:'left', paddingTop: '7px'}}>
                      Fecha:
                    </Col>
                    <Col md={9}>
                      <FormControl
                        type="date" value={this.state.fechainicio} onChange={(e) => this.onChangeFecha(e.target.value)}
                      />
                    </Col>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup validationState={this.state.error.horainicio ? 'error': null}>
                    <Col componentClass={ControlLabel} md={5} style={{textAlign:'left', paddingTop: '7px'}}>
                      Hora Inicio:
                    </Col>
                    <Col md={7}>
                      <FormControl
                        type="time" value={this.state.horainicio} onChange={(e) => this.onChangeHoraInicio(e.target.value)}
                      />
                    </Col>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup validationState={this.state.error.horafin ? 'error': null}>
                    <Col componentClass={ControlLabel} md={5} style={{textAlign:'left', paddingTop: '7px'}}>
                      Hora Fin:
                    </Col>
                    <Col md={7}>
                      <FormControl
                        type="time" value={this.state.horafin} onChange={(e) => this.onChangeHoraFin(e.target.value)}
                      />
                    </Col>
                  </FormGroup>
                </Col>
              </Row>
              <FormGroup>
                <Col componentClass={ControlLabel} md={1} style={{textAlign:'left', paddingTop: '7px'}}>
                  Sede:
                </Col>
                <Col md={11}>
                  <FormControl
                    type="text" value={this.state.sede} onChange={(e) => this.onChangeSede(e.target.value)}
                  />
                </Col>
              </FormGroup>
              {this.props.type === 'RM' &&
                <FormGroup validationState={this.state.error.mentor ? 'error': null}>
                  <Col componentClass={ControlLabel} md={1} style={{textAlign:'left', paddingTop: '7px'}}>
                    Mentor:
                  </Col>
                  <Col md={11}>
                    <Select
                      style={{ borderColor: this.state.error.mentor ? "#e40040" : "#aaa"}}
                      placeholder="Seleccione un mentor"
                      closeOnSelect={true}
                      name="usersAssignSelect"
                      value={this.state.mentor}
                      options={mentoresList}
                      onChange={(value) => { this.setState({ mentor: value}, this.clearError('mentor'))}}
                    />
                  </Col>
                </FormGroup>
              }
            </Form>

            <Row>
              <Col md={12}>
                <Form>
                  <FormGroup validationState={this.state.error.asistentes ? 'error': null}>
                    <ControlLabel>{'Asistentes del Equipo'}</ControlLabel>
                    <FormControl
                      componentClass="textarea" type="text" style={{height: 50}}
                      value={this.state.asistentes}
                      onChange={(e) => this.onChangeAsistentes(e.target.value)}
                    />
                  </FormGroup>
                </Form>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <Form>
                  <FormGroup validationState={this.state.error.objetivosconsulta ? 'error': null}>
                    <ControlLabel>{'Objetivos de la consulta'}</ControlLabel>
                    <FormControl
                      componentClass="textarea" type="text" style={{height: 50}}
                      value={this.state.objetivos}
                      onChange={(e) => this.onChangeObjetivos(e.target.value)}
                    />
                  </FormGroup>
                </Form>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <Form>
                  <FormGroup>
                    <ControlLabel style={{width: '100%'}}>
                      {'Observaciones'}
                      <Checkbox
                        style={{display: 'inline', marginTop: 0, marginBottom: 0, float: 'right'}}
                        label={'Destacar'}
                        number={'observaciones'}
                        disabled={!this.state.observaciones || this.state.observaciones === ''}
                        handleOnChange={(e) => this.setState({ observacionesChecked: e })}
                      />
                    </ControlLabel>
                    <FormControl
                      componentClass="textarea" type="text" style={{height: 50}}
                      value={this.state.observaciones}
                      onChange={(e) => this.onChangeObservaciones(e.target.value)}
                    />
                  </FormGroup>
                </Form>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <Form>
                  {this.props.type === 'RT' ?
                    <FormGroup>
                      <ControlLabel style={{width: '100%'}}>
                        {'Avances previstos para la próxima consulta'}
                        <Checkbox
                          style={{display: 'inline', marginTop: 0, marginBottom: 0, float: 'right'}}
                          label={'Destacar'}
                          number={'avances'}
                          disabled={!this.state.avances || this.state.avances === ''}
                          handleOnChange={(e) => this.setState({ avancesChecked: e })}
                        />
                      </ControlLabel>
                      <FormControl
                        componentClass="textarea" type="text" style={{height: 50}}
                        value={this.state.avances}
                        onChange={(e) => this.onChangeAvances(e.target.value)}
                      />
                      <ControlLabel style={{width: '100%'}}>
                        {'Tutores'}
                      </ControlLabel>
                      <FormControl
                        componentClass="textarea" type="text" style={{height: 50}}
                        value={this.state.tutores}
                        onChange={(e) => this.onChangeTutores(e.target.value)}
                      />
                    </FormGroup> :
                    <FormGroup>
                      <ControlLabel style={{width: '100%'}}>
                        {this.props.type === 'RAT' ? 'Sugerencias de mejora' : 'Sugerencias propuestas por el mentor'}
                        <Checkbox
                          style={{display: 'inline', marginTop: 0, marginBottom: 0, float: 'right'}}
                          label={'Destacar'}
                          number={'sugerencias'}
                          disabled={!this.state.sugerencias || this.state.sugerencias === ''}
                          handleOnChange={(e) => this.setState({ sugerenciasChecked: e })}
                        />
                      </ControlLabel>
                      <FormControl
                        componentClass="textarea" type="text" style={{height: 50}}
                        value={this.state.sugerencias}
                        onChange={(e) => this.onChangeSugerencias(e.target.value)}
                      />
                    </FormGroup>
                  }
                </Form>
              </Col>
            </Row>
            {this.props.type !== 'RM' &&
              <Row>
                <Col md={9}>
                  <FormGroup validationState={this.state.error.fechaproxima ? 'error': null}>
                    <Col componentClass={ControlLabel} md={6} style={{textAlign:'left', paddingTop: '7px'}}>
                      {this.props.type === 'RAT' ?
                      'Fecha de la pŕoxima asistencia técnica:' :
                        'Fecha de la próxima tutoría:'
                      }
                    </Col>
                    <Col md={6}>
                      <FormControl
                        type="date" value={this.state.fechaprox} onChange={(e) => {this.onChangeFechaProx(e.target.value)}}
                      />
                    </Col>
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup validationState={this.state.error.horaproxima ? 'error': null}>
                    <Col componentClass={ControlLabel} md={3} style={{textAlign:'left', paddingTop: '7px'}}>
                      Hora:
                    </Col>
                    <Col md={9}>
                      <FormControl
                        type="time" value={this.state.horaprox} onChange={(e) => {this.onChangeHoraProx(e.target.value)}}
                      />
                    </Col>
                  </FormGroup>
                </Col>
              </Row>
            }
            {this.props.type !== 'RAT' &&
              <Row>
                <Col md={this.props.type === 'RM' ? 4 : 6}>
                  <Checkbox
                    label={'Firma Tutor'}
                    number={'tutor'}
                    handleOnChange={(e) => this.setState({ firmatutor: e })}
                  />
                </Col>
                {this.props.type === 'RM' &&
                  <div>
                    <Col md={4}>
                      <Checkbox
                        label={'Firma Mentor'}
                        number={'mentor'}
                        handleOnChange={(e) => this.setState({ firmamentor: e })}
                      />
                    </Col>
                    <Col md={4}>
                      <Checkbox
                        label={'Firma Emprendedores'}
                        number={'emprendedores'}
                        handleOnChange={(e) => this.setState({ firmaemprendedor: e })}
                      />
                    </Col>
                  </div>
                }
                {this.props.type === 'RT' &&
                  <Col md={6}>
                    <Checkbox
                      label={'Firma Asistentes'}
                      number={'asistentes'}
                      handleOnChange={(e) => this.setState({ firmaasistentes: e })}
                    />
                  </Col>
                }
              </Row>
            }
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button simple onClick={this.props.cancel}>
            Cancelar
          </Button>
          <Button
            bsStyle="success" fill onClick={this.onSave}
          >
            Guardar
          </Button>
        </Modal.Footer>
      </div>
    );
  }
}

export default ModalRegistro;



// WEBPACK FOOTER //
// ./src/views/Components/ModalRegistro.jsx